import React from 'react';
import LayoutResult from '../LayoutResult';
import {
  ContRejectedResult,
  ContImgResult,
  ContInfo,
  ContResult,
  ContTitle,
  Desc,
  Title1,
  Title2,
} from './RejectedResult.styles';
import imgResult from '../../assets/images/result-rejected.svg';

const RejectedResult = () => {

  return (
    <LayoutResult>
      <ContRejectedResult>
        <ContResult className={'container-fit'}>
          <ContTitle>
            <Title1>¡Tu financiamiento</Title1>
            <Title2>no fue autorizado!</Title2>
          </ContTitle>
          <ContInfo>
            <Desc></Desc>
          </ContInfo>
          <ContImgResult>
            <img src={imgResult} alt=''/>
          </ContImgResult>
        </ContResult>
      </ContRejectedResult>
    </LayoutResult>
  );
};

export default RejectedResult;
